export default {
  customerName: 'ชื่อ - สกุล ลูกค้า',
  customerNameSocial: 'ชื่อโซเชี่ยล',
  customerPhone: 'เบอร​์โทรศัพท์',
  customerEmail: 'อีเมล์',
  customerCitizenID: 'เลขประจำตัวประชาชน',
  customerAddress: 'ที่อยู่ลูกค้า',
  customerPostalCode: 'รหัสไปรษณีย์',
  customerSelectSaleTypeID: 'ช่องทางขาย',
  customerSelectSaleTypeName: 'ช่องทางขาย',
  customerSaleSocialID: 'ช่องทางขายเพิ่มเติม',
  customerSaleSocialName: 'ช่องทางขายเพิ่มเติม'
};
